export default __webpack_public_path__ + "static/media/Ativo 70.e1fd628d.png";